<ion-content [fullscreen]="true">
   <empty-layout *ngIf="layout === 'empty'"></empty-layout>
</ion-content>
